import { isUndefined } from "./tools";

export const swapInArray = (arr, idx1, idx2) => {
    const temp = arr[idx1];
    arr[idx1] = arr[idx2];
    arr[idx2] = temp;
    // [arr[idx1],arr[idx2]] = [arr[idx2],arr[idx1]];
};


export const getArrayString = (value: any) => {
    if (Array.isArray(value)) {
        return value.join(',')?.trim()
    }
    if (typeof value === 'string') {
        return value?.trim()
    }
    return value

}

export const getStringArray = (value: any) => {
    // console.log("getStringArray",value)
    if (isUndefined(value)) return []
    if (typeof value === 'string') {
        return value.split(',')
    }
    return Array.from(value)

}

// 移除数组中对象id一样的重复元素
export function filterUniqueById(array) {
    const seen = new Map();
    return array.filter(item => {
        if (seen.has(item.id)) {
            return false;
        }
        seen.set(item.id, true);
        return true;
    });
}


// "[3,4]" => [3,4]
export const getArrayFromArrayString = (value: string, { needNumber = false } = {}) => {
    if (typeof value !== 'string') return value
    if (value.startsWith('[') && value.endsWith(']')) {
        return value.slice(1, -1).split(',').map(i => needNumber ? Number(i) : i)
    }
    return value
}